export enum FundsLocation {
    Domestic = 'domestic',
    International = 'international',
}
